import React from 'react'
import { Anchor, BasicStepper, Button, Flex, H2, LeftArrowIcon, Span } from '../../lib/components'
import { WithdrawPresenterProps } from '../../lib/types'
import { WithdrawFormStep } from '../../lib/utils/message'
import { WithdrawalAmount } from './withdrawal-amount'
import { WithdrawalRequestConfirmation } from './withdrawal-request-confirmation'

const WithdrawPresenter = ({
  backToInvestmentHandler,
  opportunity,
  currentStep,
  investmentSummary,
  withdrawalAmount,
  minWithdrawalAmount,
  maxWithdrawalAmount,
  setWithdrawalAmount,
  handleDisableButton,
  handleSubmitWithdrawalAmount,
  handlePlaceWithdrawalRequest,
  onWithdrawalPlacedSuccess,
}: WithdrawPresenterProps) => {
  const getInvestorHeadingByCurrentStep = (val: number): string => {
    if (val === 1) return 'Contact RM for Redemption'
    if (val === 2) return 'Place Redemption Request'
    return ''
  }

  return (
    <>
      {/* Back to Investment button */}
      <Flex>
        <Button
          classes={['auto-small-btn-width']}
          variant='secondary-btn'
          handleClick={backToInvestmentHandler}
          IconComponent={<LeftArrowIcon />}
        />
        <Span classes={['ml-16', 'font-16', 'mb-32']} variant='bold' text={'Back to Investment'} />
      </Flex>
      {/* Step information header */}
      <div className='withdraw-header'>
        <div className='withdraw-header-heading'>
          <H2 text={getInvestorHeadingByCurrentStep(currentStep)} />
        </div>
        <div className='withdraw-header-subheading'>
          <div>
            <Span
              text={
                currentStep === 1 ? 'Contact details for redemption from' : 'Redemption process for'
              }
            />
            <Anchor
              classes={['withdraw-header-project-title']}
              text={(opportunity && opportunity?.projectName) || ''}
              href={`/opportunity/${opportunity?.projectSlug}/${opportunity?.id}`}
              variant='basic-anchor'
            />
          </div>
        </div>
      </div>

      {/* Stepper showing current step */}
      <BasicStepper activeStep={currentStep} steps={WithdrawFormStep} />

      {/* Step 1 - Redemption amount / RM contact */}
      {currentStep === 1 && (
        <WithdrawalAmount
          opportunity={opportunity}
          investmentSummary={investmentSummary}
          withdrawalAmount={withdrawalAmount}
          minWithdrawalAmount={minWithdrawalAmount}
          maxWithdrawalAmount={maxWithdrawalAmount}
          setWithdrawalAmount={setWithdrawalAmount}
          handleDisableButton={handleDisableButton}
          backToInvestmentHandler={backToInvestmentHandler}
          handleSubmitWithdrawalAmount={handleSubmitWithdrawalAmount}
        />
      )}

      {/* Step 2 - Place Redemption Request */}
      {currentStep === 2 && (
        <WithdrawalRequestConfirmation
          opportunity={opportunity}
          withdrawalAmount={withdrawalAmount}
          handlePlaceWithdrawalRequest={handlePlaceWithdrawalRequest}
          onWithdrawalPlacedSuccess={onWithdrawalPlacedSuccess}
        />
      )}
    </>
  )
}

export { WithdrawPresenter }
